import { mapStateToProps } from '@segurosvoluntarios_vel/commons-services';
import { AppState } from 'src/app/store/state/app.state';

import { createSelector } from '@ngrx/store';
import { ConfiguracionDePago } from 'src/app/pago/models/ConfiguracionDePago.model';
import { PagoState } from 'src/app/store/state/pago.state';
import { Pago } from 'src/app/pago/models/Pago.model';
import { ResumenDescuentos } from 'src/app/pago/models/ResumenDescuentos.model';
import { ErrorPago } from 'src/app/pago/models/ErrorPago.model';

const selectFeature = (appState: AppState): PagoState => appState.pago;

export const selectConfiguracionDePago = createSelector(
  selectFeature,
  (pagoState: PagoState): ConfiguracionDePago =>
    mapStateToProps(pagoState.configuracionDePago)
);

export const selectPago = createSelector(
  selectFeature,
  (pagoState: PagoState): Pago => mapStateToProps(pagoState.pago)
);

export const selectProducto = createSelector(
  selectFeature,
  (pagoState: PagoState): string =>
    mapStateToProps(pagoState.productNameFromUrl)
);

export const selectIdPago = createSelector(selectPago, (pago: Pago): string =>
  mapStateToProps(pago.idPago)
);

export const selectDiscountsInfo = createSelector(
  selectPago,
  (pago: Pago): ResumenDescuentos => {
    const resumen: ResumenDescuentos = {
      total: pago.total,
      subTotal: pago.subTotal,
      totalDescuentos: pago.totalDescuentos,
      descuentosAplicados: pago.descuentosAplicados,
    };
    return mapStateToProps(resumen);
  }
);

export const selectUrlRedirectOtroMedioDePago = createSelector(
  selectFeature,
  (pagoState: PagoState): string => {
    return mapStateToProps(pagoState.urlRedirectOtroMedioDePago);
  }
);

export const selectError = createSelector(
  selectFeature,
  (pagoState: PagoState): ErrorPago => mapStateToProps(pagoState.error)
);

export const selectEstadoDePagoLoaded = createSelector(
  selectFeature,
  (pagoState: PagoState): boolean =>
    mapStateToProps(pagoState.estadoDePagoLoaded)
);
